module.exports = __webpack_public_path__ + "2f27e580bbff607f9fdb15ad8cb1b6f8.svg";


//////////////////
// WEBPACK FOOTER
// ../images/icons/svg/icon-snapchat-black.svg
// module id = 1003
// module chunks = 69